import React from 'react';
import { motion } from 'framer-motion';
import { DUR, EASE, splitLines } from '../../lib/motion';

// Titre révélé mot à mot : chaque mot monte derrière un masque (overflow hidden), en cascade.
// Le texte reste un vrai <h1> lisible (mots séparés par des espaces, un bloc par ligne).
// Le padding bas compense le masque pour ne pas couper les jambages (g, p, y).
export default function HeroHeadline({
  text,
  as: Tag = 'h1',
  startDelay = 0.2,
  wordDelay = 0.05,
  className = '',
  ...rest
}) {
  const lines = splitLines(text);
  let index = 0;
  return (
    <Tag className={className} {...rest}>
      {lines.map((words, li) => (
        <span key={li} className="block">
          {words.map((word, wi) => {
            const delay = startDelay + index * wordDelay;
            index += 1;
            return (
              <React.Fragment key={wi}>
                <span className="inline-block overflow-hidden align-bottom pb-[0.12em] -mb-[0.12em]">
                  <motion.span
                    className="inline-block will-change-transform"
                    initial={{ y: '110%' }}
                    animate={{ y: '0%' }}
                    transition={{ duration: DUR.slow, ease: EASE, delay }}
                  >
                    {word}
                  </motion.span>
                </span>
                {wi < words.length - 1 ? ' ' : null}
              </React.Fragment>
            );
          })}
        </span>
      ))}
    </Tag>
  );
}
